import { isRootNode } from '../dataViews/DynamicTree';
import { levelTypes } from '../../../model/OrganisationStructureLevelType';
export const types = {
    entity: 'OrganisationStructure',
    roleLevel: 'RoleXOrgLevel',
    level: 'OrgStructureLevel',
};
export const roleTypes = {
    ROLE: 'ROLE',
    ROLE_GROUP: 'ROLE_GROUP',
    ROLE_DEFAULT: 'ROLE_DEFAULT',
};
export const isRoleLevel = node => (node === null || node === void 0 ? void 0 : node.__typename) === types.roleLevel && (node === null || node === void 0 ? void 0 : node.itemType) === roleTypes.ROLE;
export const isDefaultRoleLevel = node => (node === null || node === void 0 ? void 0 : node.__typename) === types.roleLevel &&
    (node === null || node === void 0 ? void 0 : node.itemType) === roleTypes.ROLE_DEFAULT;
export const isOrgStructureLevel = node => (node === null || node === void 0 ? void 0 : node.__typename) === types.level && node.type === levelTypes.LEVEL;
export const isHiddenLevel = node => (node === null || node === void 0 ? void 0 : node.__typename) === types.level && (node === null || node === void 0 ? void 0 : node.type) === levelTypes.LEVEL_HIDDEN;
export const isEntity = node => (node === null || node === void 0 ? void 0 : node.__typename) === types.entity;
export const nodeIsSelectable = node => !isRootNode(node) && !isRoleLevel(node) && !isDefaultRoleLevel(node);
export const resolveNodeId = node => {
    if (isEntity(node)) {
        return `${types.entity}-${node.id}`;
    }
    else if (isOrgStructureLevel(node) || isHiddenLevel(node)) {
        return `${types.level}-${node.id}`;
    }
    else if (isRoleLevel(node) || isDefaultRoleLevel(node)) {
        return `${types.roleLevel}-${node.id}`;
    }
    else if (node.hasOwnProperty('_id')) {
        return node._id;
    }
    return null;
};
export const resolveNodeParentId = node => {
    const { parentId, orgStructureLevelId } = node;
    if (isEntity(node)) {
        return null;
    }
    else if (isOrgStructureLevel(node) && parentId) {
        return `${types.level}-${parentId}`;
    }
    else if (isDefaultRoleLevel(node)) {
        return null;
    }
    else if (isRoleLevel(node) && orgStructureLevelId !== null) {
        return `${types.level}-${orgStructureLevelId}`;
    }
    else if (isRoleLevel(node) && orgStructureLevelId === null) {
        return null;
    }
    return null;
};
export const nodeIsLeaf = node => isRoleLevel(node) || isDefaultRoleLevel(node);
export const nodeIsVisible = node => !isHiddenLevel(node);
export const resolveNodeClassName = node => {
    switch (true) {
        case isRootNode(node):
            return 'jstree-node-bold';
        case isDefaultRoleLevel(node):
            return 'jstree-node-italic jstree-node-disabled';
        case isRoleLevel(node):
            return 'jstree-node-italic';
        default:
            return '';
    }
};
export const nodeSortingOptions = {
    iteratees: [node => (isRoleLevel(node) ? 0 : 1), 'sequence', 'name'],
    order: 'asc',
};
export default {
    nodeIsLeaf,
    resolveNodeId,
    resolveNodeParentId,
    resolveNodeClassName,
};
